import { AddIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LearningPathsTable from "../../components/tables/LearningPathsTable";
import BasePage from "../common/BasePage";

export default function LearningPathsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToCreateLearningPath = useCallback(() => {
    navigate("./create");
  }, [navigate]);

  return (
    <BasePage title={t("learning_paths_page.learning_paths")}>
      <Flex marginBottom="10" justifyContent="flex-end">
        <Button
          bg="primary.DEFAULT"
          color="white"
          leftIcon={<AddIcon />}
          onClick={goToCreateLearningPath}
        >
          {t("common.buttons.new")}
        </Button>
      </Flex>
      <LearningPathsTable />
    </BasePage>
  );
}
